import React, { useRef } from "react";
import styles from "../Contact/Contact.module.css";
import { AiOutlineDown } from "react-icons/ai";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.send(
      "service_cqswc95",
      "template_uugr9ap",
      form.current,
      "xq6abRNe7kN6tDpnY"
    );
  };

  console.log(form.current);
  return (
    <>
      <form ref={form} onSubmit={sendEmail} className={styles.container}>
        <select name="" className={styles.select_Opt}>
          <option selected disabled={true} value="">
            Select Water Purifier - Options
          </option>
          <option value="aaa"> aaa</option>
          <option value="bbb">bbb</option>
          <option value="ccc">ccc</option>
          <option value="ddd">ddd</option>
        </select>

        <div className={styles.input_name}>
          <input type="text" placeholder="Enter Name" name="user_name" id="" />
          <input
            type="number"
            placeholder="Phone Number "
            name="user_number"
            id=""
          />
        </div>
        <div className={styles.pincode_add}>
          <input
            type="text"
            placeholder="Pincode or Address"
            name="user_message"
          />
          <input
            id={styles.btn}
            type="button"
            value="Submit"
            type="submit"
            value="Send"
          />
          <h3>Average call back time : 12 min (Last update 5 mins ago)</h3>
        </div>
      </form>

      {/* for mobile device only... */}
      <div className={styles.container2}>
        <select name="" className={styles.select_Opt2}>
          <option selected disabled={true} value="">
            Select Water Purifier - Options
          </option>
          <option value="aaa"> aaa</option>
          <option value="bbb">bbb</option>
          <option value="ccc">ccc</option>
          <option value="ddd">ddd</option>
        </select>
        <input type="text" placeholder="Enter Name" name="" id="" />
        <div className={styles.numbers}>
          <input type="number" placeholder="Phone Number " name="" id="" />
          <input type="number" placeholder="Alternative Number" name="" id="" />
        </div>
        <div className={styles.pincode_add2}>
          <input type="text" placeholder="Pincode or Address" name="" />
          <input id={styles.btn2} type="button" value="Submit" />
          <h3>Average call back time : 12 min</h3>
        </div>
      </div>
    </>
  );
};

export default Contact;
